import React            from 'react';
import classNames       from 'classnames';
import { isNullOrUndefined } from 'rewire-common';
import { Observe }           from 'rewire-core';
import Icon                  from '@material-ui/core/Icon';
import Typography            from '@material-ui/core/Typography';
import { Theme, makeStyles } from '../utility/styles';

const otherFieldCardStyle = (theme: Theme) => ({
  root: {
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  icon: {
    color: theme.palette.primary.light,
    position: 'absolute',
    top: -11
  },
  iconSubTitle: {
    flex: 1,
    fontSize: 12,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  title: {
    width: '100%',
    margin: 4,
    fontWeight: 'normal'
  },
  box: {
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 5,
    padding: 8,
    margin: 4,
    flex: 1,
    height: 38,
  },
  row: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  }
});

export const useOtherFieldCardStyle = makeStyles(otherFieldCardStyle);

interface IOtherField {
  label: string;
  icon?: string;
  get:   (item: any) => any;
  set:   (item: any, value: any) => void;
}

const OtherFieldCard = ({item, otherField}: {item: any, otherField: IOtherField}) => {
  const classes = useOtherFieldCardStyle();

  if (otherField.icon) {
    return (
      <Observe>{() => {
        if (!item) return null;
        const value = otherField.get(item);
        if (isNullOrUndefined(value)) return null;
        return (
          <div className={classNames(classes.row, classes.box)}>
            <>
              <Icon className={classes.icon}>{otherField.icon}</Icon>
              <Typography variant='subtitle1' title={value} className={classes.iconSubTitle}>{value}</Typography>
            </>
          </div>
      );}}</Observe>
    );
  }

  return (
    <Observe>{() => {
      if (!item) return null;
      const value = otherField.get(item);
      if (isNullOrUndefined(value)) return null;
      return (<Typography variant='h6' className={classes.title}>{value}</Typography>);
    }}</Observe>
  );
};

export default ({item, fields}: {item: any, fields?: IOtherField[]}) => {
  if (!fields) return null;
  return (
    <>
      {fields.map(o => <OtherFieldCard key={o.label} item={item} otherField={o} />)}
    </>
  );
};
